import { render, staticRenderFns } from "./DraftPriceEditResultTable.vue?vue&type=template&id=2a53e4b8&"
import script from "./DraftPriceEditResultTable.vue?vue&type=script&lang=js&"
export * from "./DraftPriceEditResultTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports